import { Download } from '@mui/icons-material';
import { Button, Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { DownloadMittelabrufUndVerwendungsnachweisPDF, DownloadVerwendungsnacheisPDF } from 'src/pages/private/online-antrag/DownloadAntragPDF';

export default function VNHerunterladen({ untertitel, inhalt }: { untertitel: string; inhalt: string }) {
	const { application, readOnly, saveApplication } = useApplication();

	const handleDownloadMittelabruf = async () => {
		DownloadMittelabrufUndVerwendungsnachweisPDF(application, readOnly, saveApplication);
	};

	const handleDownloadNachweis = async () => {
		DownloadVerwendungsnacheisPDF(application, readOnly, saveApplication);
	};
	return (
		<>
			<ApplicationHeading title={untertitel} description={PLATZHALTER_TEXT} />
			<MarkdownRenderer markdown={inhalt} />

			<Stack spacing={2} mb={2}>
				<Button variant='outlined' startIcon={<Download />} onClick={() => handleDownloadMittelabruf()} sx={{ maxWidth: 'fit-content' }}>
					Mittelabruf herunterladen
				</Button>

				<Button variant='outlined' startIcon={<Download />} onClick={() => handleDownloadNachweis()} sx={{ maxWidth: 'fit-content' }}>
					Verwendungsnachweis herunterladen
				</Button>

				<Divider sx={{ color: '#000', my: '2rem', pt: '2rem', borderBottom: '1px dotted' }} />
				<Typography variant='h5'>Noch Fragen?</Typography>
				<Typography>
					Sie haben noch Rückfragen zu einzelnen Bereichen? <strong>Dann melden Sie sich gerne direkt bei uns!</strong>
				</Typography>
			</Stack>
		</>
	);
}
